import { render, staticRenderFns } from "./modal-verify-phone.vue?vue&type=template&id=4455db80&"
import script from "./modal-verify-phone.vue?vue&type=script&lang=js&"
export * from "./modal-verify-phone.vue?vue&type=script&lang=js&"
import style0 from "./modal-verify-phone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports